import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Filemanager from "../../Files/Filemanager";
import { groupSource } from "../../Files/fileSources";

/**
 * The file manager, pointed at this group's file folder only. Every member
 * sees and uploads; the API says per row whether the caller may delete
 * (uploader or admin), and the file manager offers "copy to my files" on
 * group files: the post editor only attaches files the poster owns.
 */
const GroupFilesTab = ({ group }) => {
  const { t } = useTranslation();
  const sources = useMemo(() => (group?.id ? [groupSource(group)] : null), [group]);

  if (!sources) return null;

  return (
    <Filemanager
      key={group.id}
      useGrid
      showDelete
      hideTitle
      sources={sources}
      emptyText={t("Backend.Groups.Files.Empty", {
        defaultValue: "No files in this folder yet. Upload one for the whole group, or drag a file onto a folder to move it.",
      })}
    />
  );
};

export default GroupFilesTab;
